// @flow

import createAction from 'redux-actions/lib/createAction';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type HideIsPersonalisedMessageActionType = 'PERSONAL_CONTENT:HIDE_IS_PERSONALISED_MESSAGE';

export type HideIsPersonalisedMessageAction = {|
  type: HideIsPersonalisedMessageActionType,
  payload: {||},
  meta: {||},
|};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: HideIsPersonalisedMessageActionType = 'PERSONAL_CONTENT:HIDE_IS_PERSONALISED_MESSAGE';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const hideIsPersonalisedMessage: (void) => HideIsPersonalisedMessageAction = createAction(type);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default hideIsPersonalisedMessage;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/actions/hideIsPersonalisedMessage.js